export default __webpack_public_path__ + "static/media/Tech-Blog.09018db9.png";